import { render, staticRenderFns } from "./ProductBulkChange.vue?vue&type=template&id=604f9756&"
import script from "./ProductBulkChange.vue?vue&type=script&lang=js&"
export * from "./ProductBulkChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports